import { validate } from "com";
import { ORDERS_ENDPOINTS } from "./endpoints";
import type { CreateOrderPayload, CreateOrderResponse } from "./types";
import { apiPost } from "../shared";
import { validatePaymentAmount } from "./validators";

export async function createOrder(
  shoppingListId: string,
  totalAmount: number,
  shippingAddressId: string
): Promise<CreateOrderResponse> {
  validate.uuid(shoppingListId, "Shopping list ID");
  validatePaymentAmount(totalAmount);
  validate.uuid(shippingAddressId, "Shipping address ID");

  const payload: CreateOrderPayload = { shoppingListId, totalAmount, shippingAddressId };
  return apiPost<CreateOrderResponse>(ORDERS_ENDPOINTS.CREATE, payload);
}

export default createOrder;
